import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import StockControl from './StockControl';
import BreakdownDashboard from './BreakdownDashboard';
import PreventiveDashboard from './PreventiveDashboard';
import AssistantSidebar from './AssistantSidebar';
import { FaWrench, FaExclamationTriangle, FaShieldAlt, FaBoxes } from 'react-icons/fa';
import '../styles/MaintenanceHub.css';

const MaintenanceHub = ({ user, initialView }) => {
  const location = useLocation();
  const viewFromState = location.state?.view;
  const [activeView, setActiveView] = useState(viewFromState || initialView || 'stock');

  useEffect(() => {
    if (location.state?.view) {
      setActiveView(location.state.view);
    }
  }, [location.state]);

  return (
    <div className="mh-page">
      <AssistantSidebar user={null} />
      <div className="mh-container">
        <div className="mh-nav-bar">
          <div className="mh-nav-left">
            <FaWrench className="mh-nav-icon" />
            <h2>Maintenance</h2>
          </div>
          <div className="mh-view-selector">
            <button
              className={`mh-view-btn ${activeView === 'stock' ? 'active' : ''}`}
              onClick={() => setActiveView('stock')}
            >
              <FaBoxes /> Stock Control
            </button>
            <button
              className={`mh-view-btn ${activeView === 'breakdown' ? 'active' : ''}`}
              onClick={() => setActiveView('breakdown')}
            >
              <FaExclamationTriangle /> Breakdown
            </button>
            <button
              className={`mh-view-btn ${activeView === 'preventive' ? 'active' : ''}`}
              onClick={() => setActiveView('preventive')}
            >
              <FaShieldAlt /> Preventive
            </button>
          </div>
        </div>

        <div className="mh-content">
          {activeView === 'stock' && <StockControl user={user} />}
          {activeView === 'breakdown' && <BreakdownDashboard user={user} />}
          {activeView === 'preventive' && <PreventiveDashboard user={user} />}
        </div>
      </div>
    </div>
  );
};

export default MaintenanceHub;
